import axios from 'axios';

export class RestFetcher {
    baseUrl = process.env.REACT_APP_API_URL || 'https://twibbleserver-d70b8a5837f9.herokuapp.com';
    orchestratorUrl = process.env.REACT_APP_ORCHESTRATOR_URL || 'https://stormy-bastion-58275-d05188c2c43a.herokuapp.com';

    constructor(){
    }

    async fetchRooms() {
        try {
            let fetchroomsUrl = this.baseUrl + '/api/data/rooms'
            console.log(fetchroomsUrl);
            const response = await axios.get(fetchroomsUrl);
            if (response && response.data) {
                return response.data;
            }
            else {
                console.log('empty response');
            }
            
        }
        catch (error) {
            console.error('Error fetching rooms:', error);
            return [];
        }
    }

    async fetchPlayers(room) {
        try {
            let fetchPlayersUrl = this.baseUrl + '/api/data/room/' + room;
            console.log(fetchPlayersUrl);
            const response = await axios.get(fetchPlayersUrl);
            console.log('Got players');
            console.log(response.data);
            if (response && response.data) {
                return response.data;
            }
            
        }
        catch (error) {
            console.error('Error fetching players:', error);
        }
        return [];
    }

    // async connectToGame() {
    //     try {
    //       // 1. Ask orchestrator for the best server
    //       const res = await fetch(orchestratorUrl + "/available-server");
    //       const data = await res.json();
      
    //       // 2. Check if success
    //       if (!data.success) {
    //         console.error("No servers available:", data.message);
    //         return;
    //       }
      
    //       // 3. Extract the server's address from the orchestrator response
    //       const gameServerUrl = data.address; 
    //       // e.g., "http://localhost:3001" or "http://some-domain.com:4001"
      
    //       // 4. Connect to that address (Socket.io or your custom API client)
    //       const socket = io(gameServerUrl); // from 'socket.io-client'
          
    //       // 5. Now socket is connected to the dynamic address
    //       socket.on("connect", () => {
    //         console.log("Connected to game server:", socket.id);
    //         // e.g., join a room:
    //         socket.emit("joinRoom", "myRoomId");
    //       });
      
    //       socket.on("disconnect", () => {
    //         console.log("Disconnected from game server");
    //       });
      
    //     } catch (err) {
    //       console.error("Error connecting to game:", err);
    //     }
    //   }

}

